/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'eye-off': {
    width: 128,
    height: 64,
    viewBox: '0 0 128 64',
    data: '<path pid="0" d="M127 8c1.4-2.2 1-5.2-.8-6.9-2.1-1.7-4.8-1.2-6.4 1-.3.3-25.6 32.4-55.8 32.4C34.8 34.5 8.3 2 8 1.9a4.4 4.4 0 00-6.3-.5 5.2 5.2 0 00-.5 6.8c.5.8 6 7.4 14.6 14.8L4.2 36a5 5 0 00.2 6.8c.5 1 1.6 1.5 2.7 1.5s2.3-.5 3.2-1.5l12.6-14a87 87 0 0020.8 11.6l-4.8 17.4c-.7 2.7.7 5.4 3.2 6.1h1.4c2 0 3.8-1.4 4.3-3.7l4.8-17.4a58.3 58.3 0 0022.8 0L80.2 60a4.7 4.7 0 004.4 3.7c.4 0 .9 0 1.1-.3 2.5-.7 4-3.4 3.2-6.1l-4.8-17.2A87 87 0 00105 28.6l12.3 13.7c1 1 2.1 1.5 3.2 1.5s2.3-.5 3.2-1.5c1.9-2 1.9-4.9.3-6.8l-11.7-13C121.6 15 127.1 8 127.1 8z"/>'
  }
})
